import { useEffect, useRef } from 'react';

export function useDelayedToggle(delay: number = 300) {
  const timerRef = useRef<number | null>(null);

  const trigger = (callback: () => void) => {
    clear();
    timerRef.current = window.setTimeout(callback, delay);
  };

  const clear = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    return () => {
      clear();
    };
  }, []);

  return { trigger, clear };
}
